<ng-container #rendererContainer></ng-container>
<div #content>
  <ng-content></ng-content>
</div>
